// extracted by mini-css-extract-plugin
export default {"content":"Navigation_content__g+ee9"};